import { render, staticRenderFns } from "./UOttawaPreLab2.vue?vue&type=template&id=5b8d90fd&"
import script from "./UOttawaPreLab2.vue?vue&type=script&lang=ts&"
export * from "./UOttawaPreLab2.vue?vue&type=script&lang=ts&"
import style0 from "./UOttawaPreLab2.vue?vue&type=style&index=0&id=5b8d90fd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VContainer,VForm,VRow})
